import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import Utils from '../utils';

const { Session, Util, STORE_CONTEXT_TYPE } = Utils;

/**
 * This Component returns LaunchDarkly Provider
 * Uses React Web SDK: https://docs.launchdarkly.com/sdk/client-side/react/react-web
 * Usage: LaunchDarkly Provider has the flags context
 * Functional Components:
 * 			import { useFlags } from 'launchdarkly-react-client-sdk';
 * 			Make use of useFlags() hook to get Flags. For Ex: const { chatbot } = useFlags()
 * Class Components:
 * 			import { withLDConsumer } from 'launchdarkly-react-client-sdk';
 * 			export the class: withLDConsumer()(MainView);
 * 			Flags are now available from props
 * Flag names are returned in camelCase format by default
 */
export const InitializeLaunchDarkly = async () => {
	const sessionData = Session.getData();
	const { isSignedIn, accountInfo } = sessionData;
	const { planDetails = {} } = accountInfo;
	const {
		storeContext,
		IsInWinClient,
		Page = '',
		LaunchDarklyClientSideId,
	} = Session.getSettings();

	if (!isSignedIn) {
		return;
	}

	const getPlatform = () => {
		if (IsInWinClient) {
			return STORE_CONTEXT_TYPE.WINCLIENT;
		} else if (storeContext) {
			return storeContext;
		} else {
			return STORE_CONTEXT_TYPE.WEBCLIENT;
		}
	};

	// Dev note: LaunchDarkly doesn't return reject promise if there is any initialization error
	// Make use of LaunchDarklyUtil method to check for any errors
	const LDProvider = await asyncWithLDProvider({
		clientSideID: LaunchDarklyClientSideId,
		context: {
			kind: 'user',
			key: accountInfo?.userId,
			email: accountInfo?.customerDetails?.email,
			platform: 'WebClient',
			OS: Util.getOS(),
			planId: planDetails?.planId,
			accountId: accountInfo?.customerId,
			accountStatus: accountInfo?.accountStatus,
			page: Page,
			brand: 'stamps',
			webClientContext: getPlatform(),
			corpID: accountInfo?.corporationId,
		},
	});

	return LDProvider;
};
